<template>
  <div class="flex flex-col">
    <div class="flex items-center">
      <label
        :class="{
          'text-gray-600 dark:text-gray-400': disabled,
          'text-gray-900 dark:text-gray-200': !disabled
        }"
        class="ms-2 text-sm font-medium align-middle flex items-center gap-2"
      >
        <input
          :id="id || 'checkbox-' + Math.random().toString(36).substr(2, 9)"
          type="checkbox"
          :checked="modelValue"
          :disabled="disabled"
          :class="{
            'w-4 h-4 text-blue-600 bg-gray-100 border-1 border-gray-300 rounded align-middle checked:bg-blue-600 checked:border-blue-600 dark:bg-gray-700 dark:border-gray-600 dark:checked:bg-blue-600 dark:checked:border-blue-600 focus:outline-none focus:ring-0  disabled:opacity-50 disabled:bg-gray-400 disabled:border-gray-400 dark:disabled:bg-gray-600 dark:disabled:border-gray-500': true,
            'hover:bg-gray-300': !modelValue && !disabled
          }"
          aria-describedby="helper-text"
          @change="updateChecked"
        />
        <slot>
          {{ label }}
        </slot>
      </label>
    </div>
    <div v-if="helperText" class="mt-1 ml-6">
      <p
        id="helper-text"
        :class="{
          'text-gray-600 dark:text-gray-400': disabled,
          'text-gray-500 dark:text-gray-300': !disabled
        }"
        class="text-xs font-normal"
      >
        {{ helperText }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CheckboxComponent",
  props: {
    id: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    helperText: {
      type: String,
      default: null
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  methods: {
    updateChecked(event: Event) {
      const target = event.target as HTMLInputElement;
      this.$emit("update:modelValue", target.checked);
    }
  }
});
</script>

<style scoped>
input[type="checkbox"]:focus,
input[type="checkbox"]:focus-visible {
  outline: none;
  box-shadow: none !important;
}
</style>
